import { sendScenarioDataToHost } from './utils/sendScenarioDataToHost';

const LARGEST_SURFACE_RENDER = 'LargestSurfaceRender';

interface LsrScenarioData {
    sessionId: string;
    puid: string;
    miniLSR: number;
    loadMetrics: string;
}

export const sendLSRMessage = ({
    sessionId,
    puid,
    miniLSR,
    loadMetrics,
}: LsrScenarioData): void => {
    sendScenarioDataToHost({
        type: LARGEST_SURFACE_RENDER,
        data: { SessionId: sessionId, puid, loadMetrics, miniLSR },
    });
};
